import PropTypes from 'prop-types';
import React from 'react';

import './PrevArrow.scss';

export default class PrevArrow extends React.PureComponent {
    constructor(props) {
        super();
    }

    static propTypes = {
        onClick: PropTypes.func,
    };

    static defaultProps = {
        onClick: () => {},
    };

    render() {
        return (
            <div className="component-Icons-PrevArrow d-inline-flex">
                <i className="material-icons" onClick={this.props.onClick}>
                    chevron_left
                </i>
            </div>
        );
    }
}
